import de from '@translations/de/pointForm.json';
import en from '@translations/en/pointForm.json';
import pl from '@translations/pl/pointForm.json';
import sl from '@translations/sl/pointForm.json';
import uk from '@translations/uk/pointForm.json';
import bg from '@translations/bg/pointForm.json';
import cz from '@translations/cz/pointForm.json';
import fr from '@translations/fr/pointForm.json';
import gr from '@translations/gr/pointForm.json';
import it from '@translations/it/pointForm.json';
import pr from '@translations/pr/pointForm.json';
import ru from '@translations/ru/pointForm.json';
import sk from '@translations/sk/pointForm.json';
import sp from '@translations/sp/pointForm.json';
import tr from '@translations/tr/pointForm.json';
import hu from '@translations/hu/pointForm.json';
import { ITranslations } from '@/types/common';
import { PointFormTransFields } from './types';

export const pointFormTranslations: ITranslations<PointFormTransFields> = {
  name: 'pointForm',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
